<template lang="pug">
el-select(
  :model-value="modelValue",
  @update:model-value="emit('update:modelValue', $event)",
  :disabled="disabled"
)
  el-option(
    v-for="s in statusOptions",
    :key="s.value",
    :value="s.value",
    :label="$t(s.value)"
  )
    el-tag(:type="s.type") {{ $t(s.value) }}
</template>

<script setup lang="ts">
import type { TwinProperty } from "@shared/services/twinManagement";
import { statuses } from "../constants";

defineProps<{ modelValue?: string; disabled?: boolean; prop?: TwinProperty }>();
const emit = defineEmits<{ "update:modelValue": [value: string | undefined] }>();
const statusOptions = [
  { value: statuses.new, type: "info" },
  { value: statuses.planned, type: "primary" },
  { value: statuses.inProcess, type: "warning" },
  { value: statuses.completed, type: "success" },
  { value: statuses.rejected, type: "danger" },
  { value: statuses.confirmed, type: "success" },
  { value: statuses.draft, type: "info" },
] as const;
</script>
